export const HOTEL_ADS_NAV_ORDER = {
  startBooking: 1,
  selectRate: 2,
  addToCart: 3,
  viewCart: 4,
} as const

type HotelAdsNavStage = 'landing' | 'room-selection' | 'checkout'

export function hotelAdsNavStage(stage: HotelAdsNavStage, isFinal = false) {
  return {
    'data-nav-stage': stage,
    'data-nav-stage-final': isFinal ? 'true' : undefined,
  }
}

export function hotelAdsCriticalPath(order: number) {
  return {
    'data-nav-criticalpath': 'true',
    'data-nav-interactiontype': 'CLICK',
    'data-nav-interactionorder': String(order),
  }
}
